import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SaleSampleService } from "../../../services/salesample.service";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";

@Component({
  selector: "addEditInward",
  templateUrl: "./addEditInward.html",
})
export class InwardEntryComponent {
  row: any;
  data: any;
  sampledata: any = {};
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  colorList: any;
  codeList: any;
  seasonList: any;
  widthList: any[];
  invoicedata: any = {
    corcharge: 0,
    boxless: 0,
    taxper: 0,
    disper: 0,
    salesorder: false,
  };
  delPartyList: any;
  party_id: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  typeList = [
    { name: "AGENT" },
    { name: "FOR EXPO" },
    { name: "GIFT" },
    { name: "OTHERS" },
    { name: "SUSPENDS" },
  ];
  partyList: any;
  sm_type: any;

  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.sm_type = val["sale_type"];

    this.saveEvent = val["data"].tabevent;
    let sampledata = Object.assign({}, val["data"]);
    this.sampledata = sampledata;
    this.sampledata.sample_type = sampledata.sample_type;
    if (this.mode == "Edit") {
      this.editInvoiceList();

      this.oncheck(this.invoicedata.salesorder);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesInvoiceService,
    private salesampservice: SaleSampleService,
    public datePipe: DatePipe,
    public toasterService: ToasterService
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      shade: "",
      quality: "",
      type: "",
      color: "",
      sample_cut: "NO",
      swatch_cut: "NO",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
    };
    this.data = {
      barcodeList: [],
    };
  }
  ngOnInit() {
    //  this.getSalesParty();
    //  this.getSeason();
    this.tableScroll();
    this.sampledata.mode = this.mode;
    //  this.invoicedata.sales_type = this.sale_type;
    if (this.mode == "Add") {
      this.sampledata.sm_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      this.getAutoNumber();
      //this.getAuto();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  tableScroll() {
    $(".pobody").height(window.innerHeight - 400);
    $(".pobody").width(window.innerWidth - 30);
  }
  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      $("#" + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.barcodeList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.barcodeList.length > 1) {
          that.data.barcodeList.splice(ind, 1);
          that.calctot();
          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber() {
    let params = {
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
      sm_type: this.sm_type,
    };
    this.salesampservice.getAutoNumber(params).then((res: any) => {
      this.sampledata.sm_no = res;
    });
  }

  getSalesParty() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }

  /*   getSeason(){
           let params={
            start : 0,
            limit:100,
            page:1,
            date:this.datePipe.transform(new Date(), 'yyyy'),
        }
          this.salesinvservice
            .getSeason(params)
            .then((res: any) => {

                this.seasonList = res;
                 this.partyCtrl.setValue(this.invoicedata['season']);

            });
    }*/

  checkBarcode(code) {
    if (code.length == 7) {
      let params = {
        barcode: code,
      };
      for (let i = 0; i < this.data.barcodeList.length; i++) {
        if (this.data.barcodeList[i].barcode == code) {
          swal("Barcode Already Exists");
          this.sampledata.barcode = "";
          return;
        }
      }

      this.salesinvservice.checkBarcode(params).then((res: any) => {
        if (res.data.length == 0) {
          swal("Selected Design is invalid!");
          let invalidData = {
            barcode: code,
            type: "invoice",
          };
          this.invalidList.push(invalidData);
          this.sampledata.barcode = "";
          return;
        }
        let row = Object.assign(
          {
            f36: 0,
            f38: 0,
            f40: 0,
            f42: 0,
            f44: 0,
            h36: 0,
            h38: 0,
            h40: 0,
            h42: 0,
            h44: 0,
          },
          res.data
        );
        row[row.size.toLowerCase()] = 1;
        row.fqty = row.f36 + row.f38 + row.f40 + row.f42 + row.f44;
        row.hqty = row.h36 + row.h38 + row.h40 + row.h42 + row.h44;
        row.totqty = row.hqty + row.fqty;
        this.data.barcodeList.push(row);
        this.calctot();
        this.sampledata.barcode = "";
      });
    }
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season: id });
      this.invoicedata.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }

  oncheckemptyrow() {
    let design = this.data.barcodeList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.data.barcodeList = desList;
    this.onSaveInvoice();
  }

  onSaveInvoice(): void {
    if (this.sampledata.name == "") {
      swal("Enter the valid name!");
    } else if (this.sampledata.sample_type == "") {
      swal("Select the sample type!");
    } else {
      let params: any = Object.assign({}, this.sampledata);
      params["party_id"] = 0;
      params["sm_type"] = this.sm_type;
      params["tabevent"] = undefined;
      params["sm_det"] = JSON.stringify(this.data.barcodeList);
      params["sm_date"] = this.datePipe.transform(
        params["sm_date"],
        "yyyy-MM-dd"
      );
      let that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this Entry?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.salesampservice
          .save(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  onSelectPartyName(name) {
    let partylist = _.filter(this.partyList, { name: name });
    this.invoicedata.agent_id = partylist[0]["agent_id"];
    this.invoicedata.party_id = partylist[0]["genLedid"];
  }
  editInvoiceList() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      sm_id: this.sampledata.sm_id,
    };
    this.salesampservice.getSampleGridList(params).then((res: any) => {
      this.data.barcodeList = res.data;
      this.calctot();
    });
  }
  oncheck(ischeck) {
    if (ischeck == true || ischeck == "true") {
      this.invoicedata.salesorder = true;
    } else {
      this.invoicedata.salesorder = false;
    }
  }

  calctot() {
    let ftot = 0,
      htot = 0,
      tot = 0;
    for (let i = 0; i < this.data.barcodeList.length; i++) {
      ftot += parseInt(this.data.barcodeList[i]["fqty"]);
      this.sampledata.ftotal = ftot;
      htot += parseInt(this.data.barcodeList[i]["hqty"]);
      this.sampledata.htotal = htot;
      tot += parseInt(this.data.barcodeList[i]["totqty"]);
      this.sampledata.total = tot;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/Inward/addEditInward.ts